import React from 'react';
import { Modal } from 'antd';
import { Button } from '../../../components/ui';
import { useDeleteDomainMonitoring } from '../../../mutation/monitoringDomain';

export default function DeleteMonitoringDomainButton({ id }) {
  const { isLoading, mutate } = useDeleteDomainMonitoring();
  return (
    <Button
      loading={isLoading}
      type="button"
      onClick={() =>
        Modal.confirm({
          onOk: () => mutate(id),
          title: 'Do you want to delete this monitoring domain?',
        })
      }
    >
      Delete
    </Button>
  );
}
